import {
    SAVE_USER_CONTACTS,
    SAVE_USER_CONTACTS_SUCCESS,
    SAVE_USER_CONTACTS_FAILED,
    UPDATE_CONTACT_SYNC_FLAG,
    UPDATE_CONTACT_SYNC_FLAG_SUCCESS,
    UPDATE_CONTACT_SYNC_FLAG_FAILED
} from "../store/types";
import { get, set, push, update } from "firebase/database";
import {firebase} from "../config/configureFirebase";

export const saveUserContacts = (userId, contacts, platform = 'unknown') => (dispatch, getState) => {
    const {
        userContactsRef,
        singleUserRef
    } = firebase

    dispatch({
        type: SAVE_USER_CONTACTS,
        payload: null
    });

    // Prepare contacts data with metadata
    const contactsData = {
        contacts: contacts,
        syncedAt: new Date().toISOString(),
        devicePlatform: platform,
        contactCount: contacts.length,
        userId: userId
    };

    // Save contacts to Firebase and return promise
    return set(userContactsRef(userId), contactsData)
        .then(() => {
            // Update user profile with contactSynced flag
            return update(singleUserRef(userId), {
                contactSynced: true,
                contactSyncedAt: new Date().toISOString(),
                contactCount: contacts.length
            });
        })
        .then(() => {
            dispatch({
                type: SAVE_USER_CONTACTS_SUCCESS,
                payload: {
                    userId: userId,
                    contactCount: contacts.length
                }
            });
            
            // Return success for the service
            return { success: true };
        })
        .catch((error) => {
            dispatch({
                type: SAVE_USER_CONTACTS_FAILED,
                payload: error.message
            });
            
            // Return failure for the service
            return { success: false, error: error.message };
        });
};

export const updateContactSyncFlag = (userId, synced = true) => (dispatch, getState) => {
    const {
        singleUserRef
    } = firebase;

    dispatch({
        type: UPDATE_CONTACT_SYNC_FLAG,
        payload: null
    });

    // Update only the sync flag
    update(singleUserRef(userId), {
        contactSynced: synced,
        contactSyncedAt: synced ? new Date().toISOString() : null
    })
        .then(() => {
            dispatch({
                type: UPDATE_CONTACT_SYNC_FLAG_SUCCESS,
                payload: {
                    userId: userId,
                    synced: synced
                }
            });
        })
        .catch((error) => {
            dispatch({
                type: UPDATE_CONTACT_SYNC_FLAG_FAILED,
                payload: error.message
            });
        });
};

export const checkContactSyncStatus = (userId) => async (dispatch, getState) => {
    const {
        singleUserRef
    } = firebase;

    try {
        const snapshot = await get(singleUserRef(userId));
        const userData = snapshot.val();
        return !!(userData && userData.contactSynced);
    } catch (error) {
        console.log('Error checking contact sync status:', error);
        throw error;
    }
};
